import gql from "graphql-tag";

export default gql`
  mutation exportOrders($templateId: ID, $filter: OrderFilter) {
    exportOrders(templateId: $templateId, filter: $filter)
  }
`;
